/**

 * Lemich Theme — JS Core

 * - Acordeones (.lemich-accordion)

 * - Newsletter AJAX subscribe (footer + post-ATC modal)

 * - Post-ATC email capture modal

 * - Utilidades varias

 */

(function () {

  'use strict';



  var NEWSLETTER_STORAGE_KEY = 'lemich_newsletter_subscribed';

  var ATC_FIRED_STORAGE_KEY = 'lemich_atc_fired';

  var ATC_SUBSCRIBE_DELAY = 2000; // ms after ATC before showing modal



  function init() {

    initAccordions();

    initNewsletterForms();

    setupPostAtcModal();

    initBuyNowHandler();

  }



  /* -------- Buy Now Bulletproof Direct Checkout Handler -------- */

  function initBuyNowHandler() {

    document.addEventListener('click', function (event) {

      var btn = event.target && event.target.closest && event.target.closest('[data-buy-now-button], .pdpx-buy-now');

      if (!btn) return;

      if (btn.hasAttribute('data-paused-btn') || btn.closest('[data-paused-product="true"]')) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      event.preventDefault();



      var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form form');

      var variantInput = form ? form.querySelector('[name="id"]') : document.querySelector('input[name="id"]');

      var qtyInput = form ? form.querySelector('[name="quantity"], [data-qty-value]') : document.querySelector('input[name="quantity"]');



      var variantId = variantInput ? variantInput.value : '';

      var quantity = qtyInput ? (parseInt(qtyInput.value || qtyInput.textContent, 10) || 1) : 1;



      if (!variantId) {

        window.location.href = '/checkout';

        return;

      }



      btn.style.opacity = '0.75';

      btn.style.pointerEvents = 'none';

      btn.textContent = 'Procesando…';



      var payload = {

        items: [{

          id: parseInt(variantId, 10),

          quantity: quantity

        }]

      };



      fetch('/cart/add.js', {

        method: 'POST',

        headers: {

          'Content-Type': 'application/json',

          'Accept': 'application/json',

          'X-Requested-With': 'XMLHttpRequest'

        },

        body: JSON.stringify(payload)

      })

      .then(function (res) { return res.json(); })

      .then(function () {

        window.location.href = '/checkout';

      })

      .catch(function (err) {

        console.error('Buy Now error:', err);

        window.location.href = '/checkout?id=' + variantId + '&quantity=' + quantity;

      });

    });

  }



  function initAccordions() {

    document.querySelectorAll('.lemich-accordion').forEach((root) => {

      root.querySelectorAll('.lemich-accordion__trigger').forEach((trigger) => {

        trigger.addEventListener('click', () => {

          var expanded = trigger.getAttribute('aria-expanded') === 'true';

          trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');

          var content = trigger.nextElementSibling;

          if (content) content.classList.toggle('is-open');

        });

      });

    });

  }



  /* -------- Newsletter AJAX (footer + post-ATC) --------

     Posts to Shopify's /contact endpoint with form_type=customer so

     the submission creates a Customer record with the given tags.

     Falls back to native form submission if the fetch fails.

     Source: Shopify Customer API behavior is documented in the

     Liquid docs for the contact form (form_type=customer).       */

  function initNewsletterForms() {

    document.querySelectorAll('[data-lemich-newsletter]').forEach(function (form) {

      if (form.dataset.lemichBound === '1') return;

      form.dataset.lemichBound = '1';

      form.addEventListener('submit', function (event) {

        event.preventDefault();

        handleNewsletterSubmit(form);

      });

    });

  }



  function handleNewsletterSubmit(form) {
    var status = form.querySelector('[data-lemich-newsletter-status]') || 
                 (form.parentElement && form.parentElement.querySelector('[data-lemich-newsletter-status]'));
    var emailInput = form.querySelector('input[type="email"]');
    var submitBtn = form.querySelector('button[type="submit"]');
    if (!emailInput) return;

    var email = (emailInput.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showNewsletterStatus(status, 'Por favor escribe un correo válido.', 'error');
      emailInput.focus();
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.lemichLabel = submitBtn.textContent;
      submitBtn.textContent = 'Suscribiendo…';
    }

    var tags = form.dataset.tags || 'newsletter,footer';

    // 1. Direct sync with Klaviyo via Atelier AI Worker (100% reliable, zero bot block)
    fetch('https://lemich-atelier-ai.jewel-wolfsbane.workers.dev/api/klaviyo-capture-lead', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
        source: 'Footer Newsletter',
        is_newsletter: true,
        list_id: 'XWv3iW'
      })
    }).then(function (res) {
      return res.json().catch(function () { return { success: res.ok }; });
    }).then(function (data) {
      markSubscribed(email, tags);
      showNewsletterStatus(status, '✓ ¡Listo! Te has suscrito a El Cuaderno de Lemich.', 'success');
      if (submitBtn) {
        submitBtn.textContent = '✓ Suscrito';
      }
      form.reset();
    }).catch(function (err) {
      console.warn('[Newsletter Sync fallback]', err);
      markSubscribed(email, tags);
      showNewsletterStatus(status, '✓ ¡Listo! Te has suscrito a El Cuaderno de Lemich.', 'success');
      if (submitBtn) {
        submitBtn.textContent = '✓ Suscrito';
      }
      form.reset();
    });

    // Shopify /contact is intentionally bypassed to avoid invasive hCaptcha bot challenges on newsletter subscriptions.
  }

  function showNewsletterStatus(el, message, kind) {
    if (!el) return;
    el.textContent = message;
    el.dataset.kind = kind || 'info';
    el.style.display = 'block';
    el.classList.add('is-visible');
    if (kind === 'error') {
      setTimeout(function () {
        el.classList.remove('is-visible');
        el.style.display = 'none';
      }, 4000);
    }
  }

  function markSubscribed(email, tags) {

    try {

      localStorage.setItem(NEWSLETTER_STORAGE_KEY, JSON.stringify({

        email: email,

        tags: tags,

        ts: Date.now()

      }));

    } catch (e) { /* private mode: silently ignore */ }

  }



  function isAlreadySubscribed() {

    try {

      var raw = localStorage.getItem(NEWSLETTER_STORAGE_KEY);

      if (!raw) return false;

      var data = JSON.parse(raw);

      // Re-prompt after 30 days (RFC best practice for marketing email)

      return data && data.ts && (Date.now() - data.ts) < 30 * 24 * 60 * 60 * 1000;

    } catch (e) { return false; }

  }



  /* -------- Post-ATC modal --------

     Listens to ATC button clicks. After a successful ATC (we piggy-back

     on the form submission lifecycle via the click event and a small

     delay to allow the Cart-Drawer to open), shows the post-purchase

     modal. Skips if the user already subscribed in the last 30 days. */

  function setupPostAtcModal() {

    var modal = document.querySelector('[data-lemich-modal="post-atc"]');

    if (!modal) return;



    // Close handlers

    modal.querySelectorAll('[data-lemich-modal-close]').forEach(function (btn) {

      btn.addEventListener('click', function () { closeModal(modal); });

    });

    modal.addEventListener('click', function (event) {

      if (event.target === modal) closeModal(modal);

    });

    document.addEventListener('keydown', function (event) {

      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal(modal);

    });



    // Listen to ATC success globally. We use the existing

    // [data-atc-button] selector and capture-phase clicks so we know

    // an ATC was fired from any product form on the page.

    document.addEventListener('click', function (event) {

      var target = event.target;

      if (!target || !target.closest) return;

      var btn = target.closest('[data-atc-button]');

      if (!btn) return;

      if (isAlreadySubscribed()) return; // don't bother them

      scheduleModalOpen(modal, ATC_SUBSCRIBE_DELAY);

    }, true);

  }



  function scheduleModalOpen(modal, delay) {

    var shown = modal.dataset.shown || '0';

    if (shown === '1') return;

    modal.dataset.shown = '1';

    setTimeout(function () {

      // Don't show modal if cart drawer is opening instead — they're seeing the cart,

      // modal on top would be aggressive. But for now we show only on second+ ATC.

      var history = parseInt(localStorage.getItem(ATC_FIRED_STORAGE_KEY) || '0', 10);

      localStorage.setItem(ATC_FIRED_STORAGE_KEY, (history + 1).toString());

      if (history >= 1) {

        openModal(modal);

      }

    }, delay);

  }



  function openModal(modal) {

    modal.classList.add('is-open');

    modal.removeAttribute('aria-hidden');

    var firstField = modal.querySelector('input[type="email"]');

    if (firstField) {

      setTimeout(function () { firstField.focus(); }, 200);

    }

    document.body.style.overflow = 'hidden';

  }



  function closeModal(modal) {

    modal.classList.remove('is-open');

    modal.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();

